module.exports = __webpack_public_path__ + "img/login-bkgd.28b2ebdd.png";